import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  CallCenterFiltros,
  CallCenterGraficosResult,
  TaxaQualificacaoResult,
  ContatosAtualizadosTemporalResult,
  AproveitamentoListasResult,
  StatusQualificadosResult,
  MensagensPorAtendenteResult,
  ContatosSemMensagemResult,
  TaxaConversaoProjetosResult,
  PerformanceListasResult,
  ResumoPerformanceListaResult,
  PerformanceFeirasResult,
  MensagensPorDiaFeiraResult,
  PerformanceAtendentesResult
} from '../models/dashboard-call-center.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardCallCenterService {
  private apiUrl = environment.apiUrl + '/v1/Dashboard/callcenter';

  constructor(private http: HttpClient) {}

  consultarTodosGraficos(filtros: CallCenterFiltros): Observable<CallCenterGraficosResult> {
    const params = this.buildParams(filtros);
    return this.http.get<CallCenterGraficosResult>(`${this.apiUrl}/graficos`, { params });
  }

  consultarTaxaQualificacao(filtros: CallCenterFiltros): Observable<TaxaQualificacaoResult> {
    const params = this.buildParams(filtros);
    return this.http.get<TaxaQualificacaoResult>(`${this.apiUrl}/graficos/taxa-qualificacao`, { params });
  }

  consultarContatosAtualizadosTemporal(filtros: CallCenterFiltros): Observable<ContatosAtualizadosTemporalResult> {
    const params = this.buildParams(filtros);
    return this.http.get<ContatosAtualizadosTemporalResult>(`${this.apiUrl}/graficos/contatos-atualizados-temporal`, { params });
  }

  consultarAproveitamentoListas(filtros: CallCenterFiltros): Observable<AproveitamentoListasResult> {
    const params = this.buildParams(filtros);
    return this.http.get<AproveitamentoListasResult>(`${this.apiUrl}/graficos/aproveitamento-listas`, { params });
  }

  consultarStatusQualificados(filtros: CallCenterFiltros): Observable<StatusQualificadosResult> {
    const params = this.buildParams(filtros);
    return this.http.get<StatusQualificadosResult>(`${this.apiUrl}/graficos/status-qualificados`, { params });
  }

  consultarMensagensPorAtendente(filtros: CallCenterFiltros): Observable<MensagensPorAtendenteResult> {
    const params = this.buildParams(filtros);
    return this.http.get<MensagensPorAtendenteResult>(`${this.apiUrl}/graficos/mensagens-por-atendente`, { params });
  }

  consultarContatosSemMensagem(filtros: CallCenterFiltros): Observable<ContatosSemMensagemResult> {
    const params = this.buildParams(filtros);
    return this.http.get<ContatosSemMensagemResult>(`${this.apiUrl}/graficos/contatos-sem-mensagem`, { params });
  }

  consultarTaxaConversaoProjetos(filtros: CallCenterFiltros): Observable<TaxaConversaoProjetosResult> {
    const params = this.buildParams(filtros);
    return this.http.get<TaxaConversaoProjetosResult>(`${this.apiUrl}/graficos/taxa-conversao-projetos`, { params });
  }

  consultarPerformanceListas(filtros: CallCenterFiltros): Observable<PerformanceListasResult> {
    const params = this.buildParams(filtros);
    return this.http.get<PerformanceListasResult>(`${this.apiUrl}/graficos/performance-listas`, { params });
  }

  consultarResumoPerformanceLista(filtros: CallCenterFiltros): Observable<ResumoPerformanceListaResult> {
    const params = this.buildParams(filtros);
    return this.http.get<ResumoPerformanceListaResult>(`${this.apiUrl}/graficos/performance-listas/resumo`, { params });
  }

  consultarPerformanceFeiras(filtros: CallCenterFiltros): Observable<PerformanceFeirasResult> {
    const params = this.buildParams(filtros);
    return this.http.get<PerformanceFeirasResult>(`${this.apiUrl}/graficos/performance-feiras`, { params });
  }

  consultarMensagensPorDiaFeira(filtros: CallCenterFiltros): Observable<MensagensPorDiaFeiraResult> {
    const params = this.buildParams(filtros);
    return this.http.get<MensagensPorDiaFeiraResult>(`${this.apiUrl}/graficos/mensagens-por-dia-feira`, { params });
  }

  consultarPerformanceAtendentes(filtros: CallCenterFiltros): Observable<PerformanceAtendentesResult> {
    const params = this.buildParams(filtros);
    return this.http.get<PerformanceAtendentesResult>(`${this.apiUrl}/graficos/performance-atendentes`, { params });
  }

  private buildParams(filtros: CallCenterFiltros): HttpParams {
    let params = new HttpParams()
      .set('tipoPeriodo', filtros.tipoPeriodo.toString())
      .set('ano', filtros.ano.toString());

    if (filtros.mes) {
      params = params.set('mes', filtros.mes.toString());
    }
    if (filtros.dataInicio) {
      params = params.set('dataInicio', filtros.dataInicio);
    }
    if (filtros.dataFim) {
      params = params.set('dataFim', filtros.dataFim);
    }
    if (filtros.feiraId) {
      params = params.set('feiraId', filtros.feiraId);
    }
    if (filtros.listaId) {
      params = params.set('listaId', filtros.listaId);
    }
    if (filtros.atendente) {
      params = params.set('atendente', filtros.atendente);
    }

    return params;
  }
}

